import React, { FC, useEffect, useState } from "react";
import { DEMO_CAR_LISTINGS } from "data/listings";
import { CarDataType } from "data/types";
import NcImage from "shared/NcImage/NcImage";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { getAvatar } from "services/apiServices";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

export interface FleetsCardProps {
    className?: string;
    data?: CarDataType;
    size?: "default" | "small";
    model?: string
}

const DEMO_DATA: CarDataType = DEMO_CAR_LISTINGS[0];

const FleetsCard2: FC<FleetsCardProps> = ({
    size = "default",
    className = "",
    data = DEMO_DATA,

}) => {
    const {
        featuredImage,
        title,
        price,
        seats,
        model,
    } = data;

    const [profileImg, setProfileImg] = useState<any>("");

    const getProfile = async (filename: any) => {
        try {
            const profile: any = await getAvatar(filename);
            setProfileImg(URL.createObjectURL(profile))
        } catch (error) {
            setProfileImg("")
        }
    }

    useEffect(() => {
        if (featuredImage) {
            getProfile(featuredImage);
        } else {
            setProfileImg("");
        }
    }, [featuredImage])

    const renderSliderGallery = () => {
        return (
            <div className="relative w-full overflow-hidden bg-gray-100">
                <div className="aspect-w-16 aspect-h-9 relative overflow-hidden">
                    <NcImage
                        containerClassName="flex items-center justify-center h-48 md:h-56 overflow-hidden"
                        className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                        src={profileImg}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>
            </div>
        );
    };

    const navigate = useNavigate()
    
    const renderContent = () => {
        return (
            <div className={size === "default" ? "p-5 space-y-4" : "p-3 space-y-2"}>
                <div className="space-y-2">
                    <div className="flex items-start justify-between gap-2">
                        <div className="flex-1">
                            <h2 className={`capitalize font-semibold text-foreground line-clamp-1 ${size === "default" ? "text-lg" : "text-base"}`}>
                                {title}
                            </h2>
                            <p className="text-sm text-gray-500 line-clamp-1">{model}</p>
                        </div>
                    </div>
                    
                    <div className="flex items-center gap-2">
                        <span className="inline-flex items-center gap-1 bg-amber-50 text-amber-700 px-2.5 py-1 rounded-md text-xs font-medium">
                            <FontAwesomeIcon icon={faUser} className="text-xs" />
                            {seats} Seats
                        </span>
                    </div>
                </div>

                <div className="w-full border-b border-gray-100"></div>

                <div className="space-y-3">
                    {price && (
                        <div className="flex items-baseline gap-1">
                            <span className="text-2xl font-bold text-amber-600">${price}</span>
                            <span className="text-xs text-gray-500">/per day</span>
                        </div>
                    )}
                    
                    <ButtonPrimary 
                        onClick={() => navigate(`/fleetsreq/view/${data.id}`,{ state: { fleetdata: [data] } })} 
                        className="w-full rounded-lg py-2.5 font-medium transition-all duration-200 hover:shadow-lg"
                    >
                        Request Now
                    </ButtonPrimary>
                </div>
            </div>
        );
    };

    return (
        <div
            className={`nc-FleetsCard group relative border border-gray-200 rounded-xl overflow-hidden hover:border-amber-200 hover:shadow-lg transition-all duration-300 bg-white will-change-transform ${className}`}
            data-nc-id="FleetsCard"
        >
            {renderSliderGallery()}
            {renderContent()}
        </div>
    );
};

export default FleetsCard2;
